<p-dialog
  header="Usuario Autenticación"
  [modal]="true"
  [visible]="screenLock.locked()"
  [closable]="false"
  [draggable]="false"
  [style]="{ width: '450px' }">
  <form [formGroup]="form" class="flex flex-col" (ngSubmit)="login()">
    <div class="flex flex-col gap-2">
      <p-iconfield class="w-full mb-6">
        <p-inputicon class="pi pi-user" />
        <input pInputText type="text" placeholder="Usuario"
               class="w-full md:w-[25rem] text-surface-500 dark:text-surface-400 bg-surface-50 dark:bg-surface-800 border-surface-200 dark:border-surface-600"
               formControlName="usuario"/>
      </p-iconfield>
    </div>
    <div class="flex flex-col gap-2 mt-2">
      <p-iconfield class="w-full mb-6">
        <p-inputicon class="pi pi-key" />
        <p-password id="password" formControlName="password" [feedback]="false" [toggleMask]="true"
                    placeholder="*****"  inputStyleClass="w-full"
                    class="w-full md:w-[25rem] ">
          <ng-template #showicon>
            <i class="pi pi-eye-slash"></i>
          </ng-template>

          <ng-template #hideicon>
            <i class="pi pi-eye"></i>
          </ng-template>
        </p-password>
      </p-iconfield>
    </div>


    @if (errorMessage) {
      <p-message severity="error" [text]=errorMessage></p-message>
    }


    <div class="flex justify-end gap-4 mt-3 text-right">
      <p-button label="Ingresar" type="submit" styleClass="button-custom" icon="pi pi-sign-in" ></p-button>
      <p-button label="Cancelar" severity="danger" styleClass="button-custom" icon="pi pi-times" (click)="cancel()" ></p-button>
    </div>
  </form>
  <app-informacion-tienda-soporte></app-informacion-tienda-soporte>
</p-dialog>
